import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import NorthEastRoundedIcon from '@mui/icons-material/NorthEastRounded';

const KpiCard = ({
  title,
  value,
  footerText,
  borderColor,
  bgGradient,
  showArrow = false,
  onClick
}) => {
  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: '6px',
        border: `1.5px solid ${borderColor}`,
        borderRadius: '20px',
        bgcolor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        boxSizing: 'border-box',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Box
        sx={{
          background: bgGradient,
          borderRadius: '12px',
          p: { xs: 1.5, sm: 1.75, md: 2 },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 1,
          height: '100%',
          boxSizing: 'border-box'
        }}
      >
        <Box>
          <Typography
            sx={{
              color: '#64748b',
              fontSize: '13px',
              fontWeight: 650,
              fontFamily: 'Poppins',
              lineHeight: 1.15
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: '26px',
              fontWeight: 700,
              color: '#1e293b',
              mt: 0.5,
              lineHeight: 1.1,
              fontFamily: 'Poppins'
            }}
          >
            {value}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', mt: 1 }}>
          {footerText && (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mr: 1, flex: 1, minWidth: 0 }}>
              <Box sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#10B981', flexShrink: 0 }} />
              <Typography
                sx={{
                  color: '#64748b',
                  fontSize: '11.5px',
                  fontWeight: 550,
                  fontFamily: 'Poppins',
                  lineHeight: 1.2,
                  whiteSpace: 'normal',
                  wordBreak: 'break-word'
                }}
              >
                {footerText}
              </Typography>
            </Stack>
          )}

          {showArrow && (
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                bgcolor: '#ffffff',
                border: '1px solid #E2E8F0',
                display: 'grid',
                placeItems: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.02)',
                flexShrink: 0,
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: '#f8fafc',
                  borderColor: '#cbd5e1'
                }
              }}
            >
              <NorthEastRoundedIcon sx={{ fontSize: 16, color: '#64748b' }} />
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default KpiCard;
